import { render, staticRenderFns } from "./CompassCompetitorsNew.vue?vue&type=template&id=617bc860&scoped=true&"
import script from "./CompassCompetitorsNew.vue?vue&type=script&lang=ts&"
export * from "./CompassCompetitorsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bc860",
  null
  
)

export default component.exports